import { format } from "date-fns";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CrmCoachProfile } from "@/services/adminCrm";

interface Props {
  coachProfiles: CrmCoachProfile[];
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return "\u2014";
  try {
    return format(new Date(dateStr), "MMM d, yyyy");
  } catch {
    return "\u2014";
  }
}

export function UserCoachSection({ coachProfiles }: Props) {
  if (coachProfiles.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Coach Profiles</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b bg-muted/50">
                <th className="text-left px-4 py-2 font-medium">Display Name</th>
                <th className="text-left px-4 py-2 font-medium">JGS Profile ID</th>
                <th className="text-left px-4 py-2 font-medium">Linked Date</th>
              </tr>
            </thead>
            <tbody>
              {coachProfiles.map(p => (
                <tr key={p.jgsProfileId} className="border-b last:border-0">
                  <td className="px-4 py-2">{p.displayName || "\u2014"}</td>
                  <td className="px-4 py-2 font-mono text-xs">{p.jgsProfileId}</td>
                  <td className="px-4 py-2 text-muted-foreground">{formatDate(p.linkedAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
